

import React, { memo, useCallback, useContext } from 'react';
import cx from 'classnames';
import DataTableCell from '../DataTableCell';

import { Sort } from '../../../Sort';

import { DataTableContext } from '../../context/dataTableContext';
import {
  getDataTableColumnSortValue,
  getDataTableNewSort,
  isDataTableColumnSortAvailable } from
'../../utils/dataTableSort';
import '../../styles/_data-table-header-cell.scss';






const DataTableHeaderCell = (props) => {
  const { column, className } = props;

  const { sort, hasData, styleType, onSortChange } = useContext(DataTableContext);

  const { field, isSortable } = column;

  const sortValue = getDataTableColumnSortValue(field, sort);
  const isSortAvailable = isDataTableColumnSortAvailable(!!isSortable, hasData);

  const onSortClick = useCallback((newSort) => onSortChange(
    getDataTableNewSort(field, newSort)), [field, onSortChange]
  );

  return (
    <DataTableCell
      className={cx(
        'data-table-header-cell',
        {
          [`data-table-header-cell--${styleType}`]: styleType
        },
        className
      )}
      column={column}>

      {isSortAvailable ?

      <Sort value={sortValue} hasNoSort={false} onClick={onSortClick}>
            {column.header}
          </Sort> :
      column.header}
    </DataTableCell>);

};

export default memo(DataTableHeaderCell);